// import external dependencies
import 'jquery';


import 'jquery-countdown';
//import 'jquery-ui/ui/core.js';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui/ui/i18n/datepicker-no.js';


// Import everything from autoload
import './autoload/_bootstrap.js'


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
//import pageTemplateTemplateStats from './routes/stats';
import dashboard from './routes/dashboard';

//import history from './components/history';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  dashboard,

  //history,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js